import { refusDePiece } from '../../server/lib/pieces-jointes';

/**
 * Le contrôle d'une pièce avant de la lire, pour les sélecteurs de fichier du
 * module Congés.
 *
 * Il ne reste que le TYPE : aucun plafond de taille hors des factures (règle de
 * Valérie du 07/10/2026). Le dire ICI évite de lire un fichier en base64 pour
 * s'entendre refuser, et c'est la MÊME fonction que le serveur appelle — un
 * écran qui refuse ce que le serveur accepte, ou l'inverse, est le pire des deux.
 */
export function refusDuJustificatif(fichier: File): string | null {
  return refusDePiece({ mime: fichier.type });
}

/**
 * Le même contrôle, pour les pièces saisies par la RH (arrêt de travail,
 * attestation de salaire). Aujourd'hui identique — il n'y a plus de plafond
 * nulle part hors des factures —, mais nommé à part pour que la distinction
 * reste lisible : si un plafond revenait un jour sur les justificatifs du
 * salarié, ces deux appels ne devraient PAS changer ensemble.
 */
export function refusDuTypeDePiece(fichier: File): string | null {
  return refusDePiece({ mime: fichier.type });
}
